exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.travel-menu .q-btn[data-v-3683ac9a] {\n  padding: 4px 16px;\n}\n.travel-body[data-v-3683ac9a] {\n  width: 100%;\n  flex-grow: 1;\n  //height: calc(100vh - 65px);\n  overflow: auto;\n}\n.caret[data-v-3683ac9a] {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\nb[data-v-3683ac9a], strong[data-v-3683ac9a] {\n  font-weight: 700;\n}\n", ""]);

// exports
